export default __webpack_public_path__ + "data_and_magnifier.fe7829b1.png";